import { InstructorDashboard } from "pages";
import instructorRouteMap from "routeControl/instructorRouteMap";

/**
 * Generates an array of route objects for the admin dashboard.
 * @returns {Array} An array containing the route object for the admin dashboard.
 */
export default function route() {
  return [
    {
      path: instructorRouteMap.DASHBOARD.path,  // URL path for the dashboard
      name: "Dashboard",  // Display name for the route
      key: instructorRouteMap.DASHBOARD.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: instructorRouteMap.DASHBOARD.icon,  // Icon associated with the dashboard
      element: <InstructorDashboard />,  // Component to render for this route
    },
  ];
}
